import LoadingOverlay from '~/components/common/LoadingOverlay.vue';
export default {
  components: {
    LoadingOverlay
  },
  layout: 'members-area',
  mounted() {
    this.$router.replace('/members/card' + window.location.search);
  },
  methods: {}
};